module.exports = __webpack_public_path__ + "img/undraw_searching.bdb83821.svg";